import React, { useEffect, useState } from "react";
import styles from "./homeTabs.module.css";
import Animations from "../Animations/animations";
import { Link } from "react-router-dom";

const HomeTabsSection = ({ id, homeTabs, content }) => {
  const [activeTab, setActiveTab] = useState(0); // Manage active tab state
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  // Listen for window resize to update the viewport state
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Function to get the tab number with conditional styling
  const renderTabNumber = (index) => {
    const isActive = activeTab === index;
    const fontWeight = isActive ? 500 : 400;
    const color = isActive ? "#2F1C5B" : "#001111";
    return (
      <span
        style={{
          fontWeight: fontWeight,
          color: color,
        }}
        className={styles.tabNumber}
      >
        {index + 1}.{" "}
      </span>
    );
  };

  return (
    <div id={id}>
      <div>
        {id === "whoItForSec" && <Animations animationType="fadeInUp" threshold={0.2}><h2>Who is it for?</h2></Animations>}
        <div className={styles.homeTabs}>
          {homeTabs.map((tab, index) => (
            <div key={index}>
              <button
                className={`${styles.tabButton} ${
                  activeTab === index ? styles.active : ""
                }`}
                onClick={() => setActiveTab(index)}
              >
                {/* Conditionally render the tab number if id is "workingFlow" */}
                {id === "workingFlow" && renderTabNumber(index)}

                <div>
                  <h6
                    style={{
                      fontWeight:
                        id === "workingFlow"
                          ? activeTab === index
                            ? 600
                            : 400
                          : 600,
                    }}
                  >
                    {tab.heading}
                  </h6>

                  {(id === "workingFlow" ? activeTab === index : true) && (
                    <p>{tab.paragraph}</p>
                  )}
                </div>
              </button>

              {/* For mobile: show tab content only when tab is active */}
              {!isDesktop && activeTab === index && (
                <div className={styles.tabContent}>
                  <div className={styles.tabPanel}>
                    {/* Render image for content */}
                    <div className={styles.tabImage} style={{ textAlign: "center" }}>
                      <img
                        src={content[index].src}
                        alt={content[index].alt}
                        width="80%"
                        height="100%"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
       <Link to="/contact" className={styles.homeTabCta}>Get a Quote</Link>
        </div>
      </div>

      {/* For Desktop: render tab content always based on active tab */}
      {isDesktop && (
        <div className={styles.tabContent}>
          {content.map((item, index) => (
            <div
              key={index}
              className={`${styles.tabPanel} ${
                activeTab === index ? styles.visible : styles.hidden
              }`}
            >
              {/* Render image for content */}
              <Animations animationType="zoomIn" threshold={0.2}>
              <div className={styles.tabImage}>
                <img src={item.src} alt={item.alt} width="80%" height="100%" loading="lazy" />
              </div>
              </Animations>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HomeTabsSection;
